import React, { useCallback, useEffect, useRef, useState } from 'react';
import { ActionMenu } from '../../../../action-menu';
import { Button } from '../../../../button';
import { IconID } from '../../../../icon';
import { Popover } from '../../../../popover';
import { extendActionOnClick } from '../../object-table-action.util';
import styles from './action-column.module.scss';
export const ActionMenuColumn = React.memo(({ data, colDef, headerActions, eGridCell }) => {
    let actionColumn;
    if (headerActions) {
        actionColumn = {
            id: data.id,
            actions: [...headerActions],
        };
    }
    else {
        const fieldValues = data[(colDef === null || colDef === void 0 ? void 0 : colDef.field) || 'action'];
        actionColumn = {
            ...fieldValues,
        };
    }
    const [isPopoverOpen, setIsPopoverOpen] = useState(false);
    const popoverRef = useRef(null);
    const popoverContentRef = useRef(null);
    // Tracks whether the popover has ever been opened — prevents focus
    // restoration from firing on initial mount (which would scroll the last
    // row into view when all rows render with suppressRowVirtualisation).
    const wasPopoverOpenRef = useRef(false);
    // Extend the onClick functionality to close the popover on click.
    const actions = extendActionOnClick(actionColumn.actions || [], setIsPopoverOpen, data);
    const handleClosePopover = useCallback(() => {
        setIsPopoverOpen(false);
    }, []);
    // Handle focus restoration when popover closes — only after it was opened.
    useEffect(() => {
        if (isPopoverOpen) {
            wasPopoverOpenRef.current = true;
        }
        else if (wasPopoverOpenRef.current && eGridCell) {
            eGridCell.focus({ preventScroll: true });
        }
    }, [isPopoverOpen, eGridCell]);
    const handleKeyDown = useCallback((event) => {
        if (event.key === 'Tab') {
            event.preventDefault();
            handleClosePopover();
        }
    }, [handleClosePopover]);
    return (React.createElement("div", { className: styles.actionColumnContainer, "data-testid": "action-menu-column-testid" },
        React.createElement("div", { className: styles.openMenuButton, ref: popoverRef },
            React.createElement(Button, { onClick: () => {
                    setIsPopoverOpen(!isPopoverOpen);
                }, icon: IconID.MORE, type: "secondary", size: "m", ariaLabel: actionColumn.actions[0].title, "data-tooltip-content": actionColumn.actions[0].title, "data-testid": "action-menu-button" })),
        React.createElement(Popover, { align: "bottom-end", content: React.createElement(ActionMenu, { show: isPopoverOpen, menuItemGroups: actions }), targetRef: popoverRef, isVisible: isPopoverOpen, onClickOutside: handleClosePopover, onEscape: handleClosePopover, onKeyDown: handleKeyDown, popperRef: popoverContentRef })));
});
//# sourceMappingURL=action-menu-column.js.map